function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import content from './old/content';
import dataTypes from './old/dataTypes';
import isRelevant from './old/isRelevant';
import newGallerySettings from './index';
import defaultStyles from '../common/defaultStyles';
var styleList = [].concat(new Set([].concat(Object.keys(newGallerySettings), Object.keys(isRelevant), Object.keys(content))));
var mergedSettings = styleList.reduce(function (obj, styleParam) {
  var _objectSpread2;

  var settingsData = newGallerySettings[styleParam] || _objectSpread({
    styleParam: styleParam,
    isRelevant: isRelevant[styleParam]
  }, content[styleParam], {}, dataTypes[styleParam], {
    "default": defaultStyles[styleParam],
    isOld: true
  });

  return _objectSpread({}, obj, (_objectSpread2 = {}, _objectSpread2[styleParam] = settingsData, _objectSpread2));
}, {});
export default mergedSettings;